/** Heuristique visualViewport : clavier logiciel iOS/Android (WebView Capacitor inclus). */
export const SOFT_KEYBOARD_MIN_OCCLUDED_PX = 120;

export function isSoftKeyboardOpen(
  layoutViewportHeight: number,
  visualViewportHeight: number,
  minOccludedPx: number = SOFT_KEYBOARD_MIN_OCCLUDED_PX
): boolean {
  if (layoutViewportHeight <= 0 || visualViewportHeight <= 0) return false;
  return layoutViewportHeight - visualViewportHeight >= minOccludedPx;
}
